import React, { useEffect, useState } from 'react'
import { Dropdown, Modal, Nav, Tab } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { get_PushCategoryDrp, get_DataNotification, get_PushCategorySingleData } from '../../../store/actions/CommanAction';
import swal from 'sweetalert';
import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import DataTable from 'react-data-table-component';
import { customStyles } from '../Utility/Utility';
import Select from 'react-select';
import Loader from '../Loader/Loader';

const DataPushNotification = () => {
    const dispatch = useDispatch()
    const DataNotificationData = useSelector((state) => state.feedBackReducer.DataNotificationData);
    const dropdownData = useSelector((state) => state.feedBackReducer.dropdownData);
    const PushCategorySingleData = useSelector((state) => state.feedBackReducer.PushCategorySingleData);
    const customerID = Number(sessionStorage.getItem('ID'));

    const [IsActive, setIsActive] = useState(true);
    const [postModal, setPostModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [EditValue, setEditValue] = useState('')
    const [PushNotificationID, setPushNotificationID] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setloading] = useState(false);

    const [addFormData, setaddFormData] = useState({
        Category: '', CategoryID: '', NotificationTitle: '', NotificationDesc: '', CreatedByUser: '1', IsActive: '1',
    });
    const Reset = () => {
        setaddFormData({ ...addFormData, 'Category': '', 'NotificationTitle': '', 'NotificationDesc': '', })
    }
    useEffect(() => {
        dispatch(get_PushCategoryDrp());
    }, []);

    useEffect(() => {
        if (IsActive) {
            dispatch(get_DataNotification('1', setloading))
        } else {
            dispatch(get_DataNotification('0', setloading))
        }
    }, [IsActive, IsActive]);


    const filterPushData = DataNotificationData?.filter(item => {
        const query = searchQuery ? searchQuery.toLocaleLowerCase() : '';
        return (
            (item.Category && item.Category.toLocaleLowerCase().includes(query)) ||
            (item.NotificationDesc && item.NotificationDesc.toLocaleLowerCase().includes(query)) ||
            (item.NotificationTitle && item.NotificationTitle.toLocaleLowerCase().includes(query))
        );
    });
    useEffect(() => {
        if (PushCategorySingleData) {
            setEditValue(PushCategorySingleData);
        }
    }, [PushCategorySingleData]);

    useEffect(() => {
        setPushNotificationID(PushNotificationID);
        dispatch(get_PushCategorySingleData(PushNotificationID));
        setEditValue(PushCategorySingleData);
    }, [PushNotificationID])


    useEffect(() => {
        if (EditValue && EditValue.length > 0) {
            setaddFormData({
                ...addFormData,
                'PushNotificationID': PushNotificationID,
                'CategoryID': EditValue[0]?.CategoryID,
                'ModifiedByUser': '1',
                'Category': EditValue[0]?.Category,
                'NotificationTitle': EditValue[0]?.NotificationTitle,
                'NotificationDesc': EditValue[0]?.NotificationDesc,
                'NotificationCondition': EditValue[0]?.NotificationCondition,
                'IsActive': EditValue[0]?.IsActive
            });

        }
    }, [EditValue]);



    const handleAddFormSubmit = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';

        if (!error) {
            const newCustomerStory = { CategoryID: addFormData.CategoryID, Category: addFormData.Category, NotificationTitle: addFormData.NotificationTitle, NotificationDesc: addFormData.NotificationDesc, IsActive: addFormData.IsActive };
            await AddUpdate('PushNotification/Insert_PushNotification', newCustomerStory); dispatch(get_DataNotification(IsActive, setloading)); setPostModal(false)
            swal('Good job!', 'Successfully Added', "success"); Reset(); setaddFormData({ Category: '', NotificationTitle: '' });
        } else { swal('Oops', errorMsg, "error"); }
    };

    const UpdateSlider = async (event) => {
        event.preventDefault();
        let error = false;
        let errorMsg = '';
        if (addFormData.Category === "") {
            error = true;
            errorMsg = 'Please fill Skill.';
        }
        if (!error) {
            await AddUpdate('PushNotification/Update_PushNotification', addFormData);
            setEditModal(false); dispatch(get_DataNotification(IsActive, setloading)); swal('Good job!', 'Successfully update', "success");
        } else { swal('Oops', errorMsg, "error"); }
    };


    const handleAddFormChange = (e) => {
        setaddFormData({ ...addFormData, [e.target.name]: e.target.value, });
    };

    const handleEditClick = (row) => {
        dispatch(get_PushCategorySingleData(PushNotificationID)); setEditModal(true);
        setPushNotificationID(row?.PushNotificationID);
        setaddFormData({
            Category: row?.Category,
            NotificationTitle: row?.NotificationTitle,
            NotificationDesc: row?.NotificationDesc,
            PushNotificationID: row?.PushNotificationID,
        });
    };

    const ChangeDropDown = (e, name) => {
        setaddFormData((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: e ? e.value : '',
                Category: e ? e.label : '',
            };
            return updatedData;
        });
    };


    const columns = [
        {
            name: 'Category', selector: (row) => row.Category, sortable: true,
        },
        {
            name: 'NotificationDesc', selector: (row) => row.NotificationDesc, sortable: true,
        },
        {
            name: 'NotificationTitle', selector: (row) => row.NotificationTitle, sortable: true,
        },
        {
            name: (
                <p className='text-end' style={{ position: 'absolute', top: '7px', right: 50 }}>Action</p>
            ),
            cell: row => (
                <div style={{ position: 'absolute', top: 4, right: 50 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item onClick={() => handleEditClick(row)}>Edit</Dropdown.Item>
                            <Dropdown.Item className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.PushNotificationID, true, '0');
                                }}
                            >
                                Inactive
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        }
    ];

    const columns1 = [

        {
            name: 'Category', selector: (row) => row.Category, sortable: true,
        },
        {
            name: 'NotificationTitle', selector: (row) => row.NotificationTitle, sortable: true,
        },
        {
            name: 'NotificationDesc', selector: (row) => row.NotificationDesc, sortable: true,
        },
        {
            name: <p className='text-end' style={{ position: 'absolute', top: '7px', right: 0 }}>Action</p>,
            cell: row => <>
                <div style={{ position: 'absolute', top: 4, right: 5 }}>
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#342E59" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                            <Dropdown.Item
                                className={row.IsActive ? "text-danger" : "text-success"}
                                onClick={() => {
                                    handleToggleStatusClick(row.PushNotificationID, false, '1');
                                }}>
                                Active
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </>
        }
    ];

    const handleToggleStatusClick = async (PushNotificationID, currentStatus, isActiveValue) => {
        const postData = { PushNotificationID: PushNotificationID, DeleteByUser: customerID, IsActive: isActiveValue, };
        await AddUpdate('PushNotification/Delete_PushNotification', postData);
        swal('Good job!', `Successfully ${isActiveValue === '1' ? 'Active' : 'Inactive'}`, "success");
    };


    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: "#fdba74",
            boxShadow: "none",
            "&:hover": {
                borderColor: "#fdba74",
            },
        }),
    };


    return (
        <>

            <Tab.Container defaultActiveKey="All">
                <div className='main_card mb-4'>
                    <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Push Notification</h2>
                    <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap">
                        <div className="card-action coin-tabs">
                            <Nav as="ul" className="nav nav-tabs" role="tablist">
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link className="nav-link" eventKey="All" onClick={(currentStatus) => {
                                        setIsActive(true);
                                        setSearchQuery('');
                                    }} >Active</Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li" className="nav-item">
                                    <Nav.Link className="nav-link" eventKey="Inactive" onClick={(currentStatus) => {
                                        setIsActive(false);
                                        setSearchQuery('');
                                    }}>Inactive</Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </div>
                        <Link to={"#"} className="btn btn-primary font-w600 " onClick={() => { setPostModal(true); Reset() }}>+ New Notification</Link>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="main_card mt-0">
                            <div className=" p-0">
                                <Tab.Content>
                                    <Tab.Pane eventKey="All">
                                        <div className="mb-sm-3 d-flex flex-wrap align-items-center text-head">
                                            <Modal className="modal fade" show={postModal} onHide={() => setPostModal(false)} backdrop="static">
                                                <form>
                                                    <div className="modal-header">
                                                        <h4 className="modal-title fs-20">Add Notification</h4>
                                                        <button type="button" className="btn-close" onClick={() => setPostModal(false)} data-dismiss="modal"></button>
                                                    </div>

                                                    <div className="modal-body p-3">
                                                        <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                        <div className="add-contact-box">
                                                            <div className="form-group mb-3 col-12">
                                                                <label className="text-black font-w500">Category</label>
                                                                <div className="contact-name">
                                                                    <Select
                                                                        name="CategoryID"
                                                                        value={dropdownData?.find((obj) => obj?.label === addFormData?.CategoryID)}
                                                                        options={dropdownData}
                                                                        onChange={(e) => ChangeDropDown(e, 'CategoryID', 'Category')}
                                                                        placeholder="Select Highest Category"
                                                                        isClearable
                                                                        styles={selectStyles}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="add-contact-content">
                                                                <div className="form-group">
                                                                    <div className="d-flex align-items-center">
                                                                        <label htmlFor="" className="text-black font-w500">Title</label>
                                                                        <span className="text-danger star-error" >*</span>
                                                                    </div>
                                                                    <input type="text" className="" autoComplete="off"
                                                                        name="NotificationTitle" required="required"
                                                                        value={addFormData?.NotificationTitle} onChange={handleAddFormChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="add-contact-box">
                                                                <div className="add-contact-content">
                                                                    <div className="form-group">
                                                                        <div className="d-flex align-items-center">
                                                                            <label htmlFor="" className="text-black font-w500">Description</label>
                                                                            <span className="text-danger star-error" >*</span>
                                                                        </div>
                                                                        <input type="text" className="" autoComplete="off"
                                                                            name="NotificationDesc" required="required"
                                                                            value={addFormData?.NotificationDesc} onChange={handleAddFormChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer">
                                                        <button type="submit" className="btn btn-primary" onClick={handleAddFormSubmit}>Save</button>
                                                        <button type="button" onClick={() => { setPostModal(false); Reset() }} className="btn btn-danger">
                                                            <i className="flaticon-delete-1"></i> Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </Modal>
                                        </div>
                                        <Modal className="modal fade " show={editModal} onHide={setEditModal} backdrop="static">
                                            <div className="" role="document">
                                                <div className="">
                                                    <form >
                                                        <div className="modal-header">
                                                            <h4 className="modal-title fs-20">Edit Notification</h4>
                                                            <button type="button" className="btn-close" onClick={() => setEditModal(false)} data-dismiss="modal"></button>
                                                        </div>
                                                        <div className="modal-body p-3">
                                                            <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
                                                            <div className="add-contact-box">

                                                                <div className="form-group col-12">
                                                                    <label className="text-black font-w500">Category</label>
                                                                    <div className="contact-name">
                                                                        <Select
                                                                            name="CategoryID"
                                                                            value={dropdownData?.find((obj) => obj.value === addFormData?.CategoryID) || null} // Match based on value
                                                                            options={dropdownData}
                                                                            onChange={(e) => ChangeDropDown(e, 'CategoryID', 'Category')}
                                                                            placeholder="Select Highest Category"
                                                                            isClearable
                                                                            isDisabled
                                                                            styles={selectStyles}
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="form-group mb-3 col-12">
                                                                    <div className="d-flex align-items-center">
                                                                        <label htmlFor="" className="text-black font-w500">Title</label>
                                                                        <span className="text-danger star-error" >*</span>
                                                                    </div>
                                                                    <input type="text" className="" autoComplete="off"
                                                                        name="NotificationTitle" required="required"
                                                                        value={addFormData?.NotificationTitle} onChange={handleAddFormChange}
                                                                    />
                                                                </div>

                                                                <div className="form-group mb-3 col-12">
                                                                    <div className="d-flex align-items-center">
                                                                        <label htmlFor="" className="text-black font-w500">Description</label>
                                                                        <span className="text-danger star-error" >*</span>
                                                                    </div>
                                                                    <input type="text" className="" autoComplete="off"
                                                                        name="NotificationDesc" required="required"
                                                                        value={addFormData?.NotificationDesc} onChange={handleAddFormChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        

                                                        <div className="modal-footer">
                                                            <button type="submit" className="btn btn-primary" onClick={UpdateSlider}>Update</button>
                                                            <button type="button" onClick={() => { setEditModal(false); Reset() }} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Close</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Modal>

                                        <div
                                            className="input-group search-area text-end"
                                            style={{ marginLeft: "auto", maxWidth: "300px" }}
                                        >
                                            <input
                                                type="text"
                                                className={`form-control text-dark`}
                                                placeholder="Search Astrologers..."
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                            <span className="input-group-text">
                                                <Link to={"#"}><i className="flaticon-381-search-2"></i></Link>
                                            </span>
                                        </div>

                                        <div className="col-12 mt-2">
                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <DataTable
                                                    dense
                                                    data={filterPushData}
                                                    columns={columns}
                                                    selectableRowsHighlight
                                                    pagination
                                                    persistTableHead={true}
                                                    noDataComponent={"There are no data to display"}
                                                    customStyles={customStyles}
                                                />)}
                                        </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="Inactive">
                                        <div className="row">
                                            <div className="col-12 mt-2">
                                                {loading ? (
                                                    <Loader />
                                                ) : (
                                                    <DataTable
                                                        dense
                                                        data={filterPushData}
                                                        columns={columns1}
                                                        selectableRowsHighlight
                                                        highlightOnHover
                                                        pagination
                                                        fixedHeader
                                                        persistTableHead={true}
                                                        noDataComponent={"There are no data to display"}
                                                    />)}
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </div >
            </Tab.Container >

        </>
    )
}
export default DataPushNotification